// Helper function to escape regex special characters
function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

export const BANNED_REGEX = new RegExp(
  [
    ".COM",
    ".ORG",
    "4SKIN",
    "@NUS",
    "@RSE",
    "@SS",
    "ADMIN",
    "AIDS",
    "AMCIK",
    "ANAL",
    "ANUS",
    "ARSE",
    "ASS",
    "ATOUCHE",
    "AYIR",
    "B17CH",
    "B1TCH",
    "B@LL@CKS",
    "BAGGERS",
    "BAGGING",
    "BALLS",
    "BASTARD",
    "BELCH",
    "BI7CH",
    "BITCH",
    "BLOODY",
    "BLOW-JOB",
    "BLOWJOB",
    "BOGIE",
    "BOIOLAS",
    "BOLLOCK",
    "BOLLOX",
    "BOLOX",
    "BONER",
    "BONK",
    "BOOBS",
    "BREAST",
    "BROTHEL",
    "BUGGER",
    "BUKKAKE",
    "BUM",
    "BUTTHOLE",
    "BUTTOCK",
    "C0CK",
    "CABRON",
    "CASTRATE",
    "CASTRATION",
    "CAWK",
    "CAZZO",
    "CHINK",
    "CHRAA",
    "CHUJ",
    "CIPA",
    "CLIT",
    "CNUT",
    "CO.UK",
    "COCK",
    "COON",
    "COTTAGING",
    "CRAP",
    "CRAUT",
    "CRETIN",
    "CRIP",
    "CRIPP",
    "CUM",
    "CUNE",
    "CUNNILINGUS",
    "CUNT",
    "D4MN",
    "DAGO",
    "DAMN",
    "DARKIE",
    "DARKY",
    "DAYGO",
    "DEAD",
    "DEGO",
    "DICK",
    "DIED",
    "DILDO",
    "DIRSA",
    "DOGGING",
    "DOUCHEBAG",
    "DUPA",
    "DYKE",
    "DZIWKA",
    "EKREM",
    "EKTO",
    "ENCULER",
    "F@CK",
    "FACT HUNT",
    "FAECES",
    "FAEN",
    "FAG",
    "FANCUL",
    "FART",
    "FATASS",
    "FCUK",
    "FECES",
    "FELCH",
    "FELLATIO",
    "FICKEN",
    "FIDDLE",
    "FISTING",
    "FITTA",
    "FITTE",
    "FLIKKER",
    "FORESKIN",
    "FORSKIN",
    "FOTZE",
    "FOURSKIN",
    "FUCK",
    "FUK",
    "FUTKRETZN",
    "FUX0R",
    "GAY",
    "GISEM",
    "GISSEM",
    "GISSUM",
    "GOD",
    "GOLLIWOG",
    "GUIENA",
    "GYPO",
    "GYPSY",
    "GYSM",
    "GYZM",
    "H0R",
    "H4X0R",
    "HATE",
    "HELVETE",
    "HITLER",
    "HOER",
    "HOMOSEXUAL",
    "HONKEY",
    "HUEVON",
    "HUI",
    "INJUN",
    "JAVASCRIPT",
    "JEW",
    "JISM",
    "JIZZ",
    "JSCRIPT",
    "JYSM",
    "JYZM",
    "KAWK",
    "KIKE",
    "KNULLE",
    "KRAUT",
    "KUK",
    "KUKSUGER",
    "KUNT",
    "KURAC",
    "KURWA",
    "KUSI",
    "KYRP",
    "LABIA",
    "LESBIAN",
    "LESBO",
    "LICKER",
    "MAMHOON",
    "MANGINA",
    "MASTERBATE",
    "MASTURBAT",
    "MERD",
    "MERDE",
    "MIBUN",
    "MIKE HUNT",
    "MINGE",
    "MINJE",
    "MONG",
    "MONKLEIGH",
    "MOULIEWOP",
    "MUFF",
    "MUIE",
    "MULKKU",
    "MUSCHI",
    "NAZI",
    "NEPESAURIO",
    "NIGA",
    "NIGER",
    "NIGGA",
    "NIGGER",
    "NIPPLE",
    "NOB",
    "NONCE",
    "NUTSACK",
    "OOTZAK",
    "OROSPU",
    "PAEDO",
    "PAKI",
    "PASKA",
    "PEADO",
    "PEEDO",
    "PENDEJO",
    "PENIS",
    "PERV",
    "PHUCK",
    "PICKA",
    "PIERDOL",
    "PIKEY",
    "PILLU",
    "PIMMEL",
    "PIMP",
    "PISS",
    "PIZDAPOONTSEE",
    "PLONKER",
    "PR0N",
    "PRETEEN",
    "PREUD",
    "PRICK",
    "PROSTITUTE",
    "PULA",
    "PULE",
    "PUSSE",
    "PUSSY",
    "PUTA",
    "PUTO",
    "QAHBEH",
    "QUEEF",
    "QUEENING",
    "QUEER",
    "QUIM",
    "QWEEF",
    "RAUTENBERGSCHAFFER",
    "RIMJOB",
    "RIMMING",
    "SATAN",
    "SCHEISS",
    "SCHEISSE",
    "SCHLAMPE",
    "SCHMUCK",
    "SCROTUM",
    "SCUM",
    "SEX",
    "SHIT",
    "SH!T",
    "SHLT",
    "SH1T",
    "SH?T",
    "SHAG",
    "SHARMUTA",
    "SHARMUTE",
    "SHEMALE",
    "SHIAT",
    "SHIPAL",
    "SHIZ",
    "SHYTE",
    "SKRIBZ",
    "SKURWYSYN",
    "SLAG",
    "SLUT",
    "SMUT",
    "SOD",
    "SPASTIC",
    "SPAZ",
    "SPHENCTER",
    "SPIC",
    "SPIERDALAJ",
    "SPIK",
    "SPLOOGE",
    "SPUNK",
    "SUCK",
    "SUKA",
    "SUPERUSER",
    "TITS",
    "TOSSER",
    "TWAT",
    "VAGINA",
    "VBSCRIPT",
    "WANK",
    "WHORE",
    "WIGA",
    "WIGGA",
    "WOP",
    "WWW",
    "YID",
  ]
    .map(escapeRegExp)
    .join("|")
);

export const WHITELIST = new Set([
  "AMONG",
  "ARSENAL",
  "ASSEMBLE",
  "ASSOCIATES",
  "BASSETT",
  "CLASS",
  "ESSEX",
  "GLASS",
  "GODFREY",
  "JURASSIC",
  "MASSINGHAM",
  "MASSIVE",
  "SCUNTHORPE",
  "SUSSEX",
  "WIGAN",
]);
